import VarighetTypeValg from '../Utilities/VarighetTypeValg';

export function formatNumber(tall: number | undefined, locale: string = 'nb-NO') : string {
    if(tall === undefined)
        return "";

    let tallSomString: string = tall.toString();
    if(locale === 'en-US') {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
    } else {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
    }
    
    return tallSomString;
}

export function hentAntallDagerDetSkalRegnesStipendOgLanFor(valgtVarighet: string | undefined): number {
    if(valgtVarighet === undefined)
        return 0;

    if(valgtVarighet === VarighetTypeValg.a1_hele) {
        return 330;
    }
    if(valgtVarighet === VarighetTypeValg.a2_host) {
        return 150;
    }
    if(valgtVarighet === VarighetTypeValg.a3_vaar) {
        return 180;
    }
    return 0;
}